export default "__VITE_ASSET__b3a73bc8__"